var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.sortBy === _vm.name
    ? _c("span", { staticClass: "arrow__container" }, [
        _vm.asc
          ? _c("svg", { staticClass: "arrow" }, [
              _c("use", {
                attrs: { x: "0", y: "2", "xlink:href": "#sort_asc" }
              })
            ])
          : _c("svg", { staticClass: "arrow" }, [
              _c("use", {
                attrs: { x: "0", y: "2", "xlink:href": "#sort_desc" }
              })
            ])
      ])
    : _c("span", { staticClass: "arrow__container" }, [
        _c("div", { staticClass: "arrow" })
      ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-eccc6bec", { render: render, staticRenderFns: staticRenderFns })
  }
}